import { Navigate, RouteObject } from "react-router-dom";
import { UserConsentPage } from "../pages";

const consentRoutes: RouteObject[] = [
    {
        path: '/',
        element: <UserConsentPage />
    },
    {
        path: '*',
        element: <Navigate to="/" replace />
    }
]

export default consentRoutes;